import axios from "axios";
import { useQuery } from "react-query";
import { API_ENDPOINT } from "../utils/constants";
import { getDbHeader } from "../utils/util";

const useCategoryChecker = (token) => {
  return useQuery({
    queryKey: ["check-product-categories", token],
    queryFn: async () => {
      const response = await axios.get(
        `${API_ENDPOINT}event/check-product-categories`,
        getDbHeader(token)
      );
      return response.data;
    },
    enabled: !!token, // Prevent execution if id or token is missing
    retry: (failureCount, error) => {
      if (!error.response) return true; // Retry on network errors
      const status = error.response.status;
      return status !== 401 && status !== 404 && status !== 500; // No retries for 404/500
    },
  });
};

export default useCategoryChecker;
